import React, {useState} from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idQuestionUpdate, validateQuizImageSize, 
    validateQuizImageType, uploadQuizImg, imgQuestionDelete, openDeleteInputFormsForQuestionsImg } from '../../../adminSlice';

import { validateFileTypeNote, validateFileSizeNote } from '../../../../../helper/validation';


const InputFormsForQuestions  = (props) => {

    //const [userInputId, setUserInputId] = useState('');
    const [userInputContent, setUserInputContent] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [validate, setValidate] = useState(false); 
    const [typeQuest, setTypeQuest] = useState(1);
    
    const { dispatch } = props;

    // HANDLE CHECK IMG EDIT
/*
    const handleEditImageNotePart = () => {
        setCheckImg(!checkImg);
        if (activeAdminStyle) {
            clearInputFile();
            clearPreviewPartNote();
            clearImgText();
        }
    } 
    */
    // SET AFF NOTE FILES
    const selectFiles = (e) => {
        
        setSelectedFiles(e.target.files);
        console.log(e.target.files[0]);

            //validate type image
            const addFile = document.getElementById('quiz-img');
            console.log(addFile);
            let valideTypeMessage = validateFileTypeNote(addFile);
            
           dispatch(validateQuizImageType(valideTypeMessage));
            //validate size image
            let valideSizeMessage = validateFileSizeNote(addFile);
           // console.log(valideTypeMessage);
            console.log(valideSizeMessage);
           // console.log(e.target.files);
           dispatch(validateQuizImageSize(valideSizeMessage));
        console.log(e.target.files.length);

       if ((valideTypeMessage === true) && (valideSizeMessage === true) && (e.target.files.length !== 0)) {
        setValidate(true);
        
       } else {
        setValidate(false);
       }


    } 

       //HANDLE UPLOAD -ADD PART NOTE
    const handleUploadAddQuizImg = e => {
       console.log('WTF');
           
           e.preventDefault();
    
            //const valideTypeMessage = false;
            //const valideSizeMessage = false;
           const valideTypeMessage = props.adminState.errorQuizImageValidateType;
           const valideSizeMessage = props.adminState.errorQuizImageValidateSize;
    
       
       if (!valideTypeMessage && !valideSizeMessage) {
          console.log('START UPLOAD QUIZ IMG AFTER GOOD VALIDATION');
          // console.log(props.selectedIdNote, notePartTitle,notePart,noteText,noteImgText, selectedFiles );
           let formData = new FormData();
           console.log(props.adminState.selectedQuize);
           console.log(props.adminState.selectedId);
           formData.append("quiz_id",props.adminState.selectedQuize);
           formData.append("question_id",props.adminState.selectedId);
           formData.append("file", selectedFiles[0]);
           
           console.log(formData);
          dispatch(uploadQuizImg(formData));
    
       
          //clear input forms
           clearInputForms();
           clearInputFile();
    
       
       } else return null;
       
         
         }
    //CLEAR INPUT FILE NAME
    const clearInputFile = () => {
    document.getElementById('quiz-img').value = '';
    }
    // CLEAR INPUT FORMS
    const clearInputForms = () => {
        
        setSelectedFiles([]);
    } 


 // CLICK OK
    const onSend = () => {
        const { dispatch } = props;

        const item = {
            question_id: props.adminState.selectedId,
            question_content: userInputContent,
            sort_quest: typeQuest,
            
        }
        dispatch(idQuestionUpdate(item));  
    }
// ENTER INPUT
    const handleUserInputContent = (e) => {

            setUserInputContent(e.target.value);

    }



// CLOSE FORM
    const onClose = () => {
    const { dispatch } = props;
    dispatch(closeInputForms());

    }

       //HANDLE DELETE QUIZ IMG
    const handleDeleteQuizImg = e => {
       console.log('WTF');
       dispatch(openDeleteInputFormsForQuestionsImg());

       /*
   
            const item = {
                quizId: props.adminState.selectedQuize,
                questionId: props.adminState.selectedId,
                imgName: props.adminState.selectedImgName
            }
            console.log(item);
        dispatch(imgQuestionDelete(item));
    */
       
          //clear input forms
          // clearInputForms();
          // clearInputFile();
    
    }    
// CHOOSE TYPE QUESTION
const handleTypeQuest = (e) => {

   console.log('type question');
   console.log(typeof(e.target.options[e.target.selectedIndex].value));
    setTypeQuest(Number(e.target.options[e.target.selectedIndex].value));

}
   
    
        //console.log(this.props.adminState.openInputForms);
     if (props.adminState.openInputFormsForQuestions) {
        return(
            <div className="InputFormsForQuizes">
                <p>Изменить вопрос:</p>
                <p p className="p-text">id: {props.adminState.selectedId}</p>
                <p p className="p-text">Старый вопрос: {props.adminState.dataQuestionsId.map(item => {
               //console.log(this.props.adminState.selectedId)
                if (item.id === Number(props.adminState.selectedId))
                //{ console.log(item.text)}
                {return item.text;} else return null;
                })}
                </p>
                


             
             <form>
                 <label>
                     Введите новый вопрос: </label>
                 <textarea  onChange={handleUserInputContent} 
                 ></textarea>
                 <label for="typequest">Тип вопроса</label>
                        <select name="typequest"  onChange={handleTypeQuest}>
                            <option value="" selected disabled hidden>Выбрать тип вопроса</option>
                                <option value="1">1 тип</option>
                                <option value="2">2 тип</option>
                                <option value="3">3 тип</option>
                                <option value="4">4 тип</option>

                                
                        </select>


             </form>
             <button onClick={onSend}>Сохранить</button>
             <form>
                <p>Изменить/Добавить изображение:</p>
                {/*<fieldset>
                    <legend>Изменить/Добавить изображение</legend>

                        <div>
                            <input type="checkbox" className="input-checkbox" id="img-quest-quiz" name="img" 
                            value={checkImg} onChange={handleEditImageNotePart} 
                            checked={checkImg}/>
                            <label htmlFor="img"></label>
                        </div> 
                        
                </fieldset>  */}           
                <input id='quiz-img' className="input-selected" type="file" accept="image/*" onChange={selectFiles}  />
             </form>
             <p className='p-text'>Допустимые форматы -jpg, jpeg, gif, png, webp. Допустимый размер файла до 0.5Мб</p>
             {props.adminState.errorQuizImageValidateSize ? <p className='err-text'>{props.adminState.errorQuizImageValidateSize}</p> : null}
             {props.adminState.errorQuizImageValidateType ? <p className='err-text'>{props.adminState.errorQuizImageValidateType}</p> : null}
             
             <button className='upload' onClick={handleUploadAddQuizImg } disabled={ validate ? false : true}> Загрузить</button>
             <p>Удалить изображение:</p>
             <button className='upload' onClick={handleDeleteQuizImg } disabled={props.adminState.selectedImgName ? '' : 'disabled'}> Удалить</button>
             <button onClick={onClose}>Закрыть</button>
            </div>
        )
     } else return null;
       
     

        
    
}
export default InputFormsForQuestions;